export class CustomCollabOnboard {
  private static readonly CREATOR_ID_KEY = "destinationCreatorId";
  private static readonly PACKAGE_ID_KEY = "destinationPackageId";

  static setCreatorPackageInContext(creatorId: string, packageId: string): void {
    localStorage.setItem(this.CREATOR_ID_KEY, creatorId);
    localStorage.setItem(this.PACKAGE_ID_KEY, packageId);
  }

  static getCreatorPackageInContext(): { creatorId: string | null; packageId: string | null } {
    return {
      creatorId: localStorage.getItem(this.CREATOR_ID_KEY),
      packageId: localStorage.getItem(this.PACKAGE_ID_KEY),
    };
  }

  static removeCreatorPackageFromContext(): void {
    localStorage.removeItem(this.CREATOR_ID_KEY);
    localStorage.removeItem(this.PACKAGE_ID_KEY);
  }

  static hasCreatorPackageInContext(): boolean {
    return !!localStorage.getItem(this.CREATOR_ID_KEY) && !!localStorage.getItem(this.PACKAGE_ID_KEY);
  }
}
